<template>
  <div v-if="visible" class="success-modal">
    <div class="success-modal__content">
      <div class="success-modal__icon">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="success-modal__check">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
        </svg>
      </div>
      <div class="success-modal__text"> {{ $t('form.success-modal') }} </div>
      <ButtonClose
        :buttonText="$t('button.close')"
        @click="closeModal"
      />
    </div>
  </div>
</template>

<script>
import ButtonClose from "@/components/Buttons/ButtonClose.vue";

export default {
  name: "SuccessModal",
  components: { ButtonClose },
  props: {
    visible: {
      type: Boolean,
      required: true,
    }
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
  },
};
</script>
